import { authStateAtom } from '@/entities/auth/model/auth.atom';
import { getDefaultStore } from 'jotai';

/**
 * 인메모리에 저장된 accessToken을 가져옵니다.
 * 서버 사이드나 클라이언트 사이드에서 사용 가능합니다.
 *
 * @returns accessToken 또는 null
 */
export function getAccessToken(): string | null {
  const store = getDefaultStore();
  const authState = store.get(authStateAtom);
  return authState.accessToken;
}

/**
 * Authorization 헤더를 생성합니다.
 * 인메모리의 accessToken을 사용합니다.
 *
 * @returns Authorization 헤더 객체 또는 빈 객체
 */
export function createAuthHeaderFromMemory(): Record<string, string> {
  const token = getAccessToken();
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
  };
}
